type NavLike = { userAgentData?: { platform?: string }; platform?: string };

export function detectIsMac(nav?: NavLike): boolean {
  if (!nav) return false;
  const platform = nav.userAgentData?.platform ?? nav.platform ?? '';
  return /mac|iphone|ipad/i.test(platform);
}

export const isMac = detectIsMac(
  typeof navigator !== 'undefined' ? (navigator as unknown as NavLike) : undefined,
);

export function getShortcutLabel(mac: boolean): string {
  return mac ? '⌘J' : 'Ctrl+J';
}

export const shortcutLabel = getShortcutLabel(isMac);

export function matchesAssistantShortcut(
  e: Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey'> & {
    isComposing?: boolean;
  },
  mac: boolean,
): boolean {
  if (e.isComposing) return false;
  if (typeof e.key !== 'string' || e.key.toLowerCase() !== 'j') return false;
  return mac ? e.metaKey && !e.ctrlKey : e.ctrlKey && !e.metaKey;
}

export function isAssistantShortcut(e: KeyboardEvent): boolean {
  return matchesAssistantShortcut(e, isMac);
}
